export function normalizeUrl(url: string, urlSchema: string) {
    let normalizedUrl = url.toLowerCase().trim();
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        normalizedUrl = urlSchema.concat(url);
    }
    return normalizedUrl;
}

export function base64ToArrayBuffer(base64: string) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    let bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }

    return bytes.buffer;
}

export function shuffleArray<T>(arr: T[]) {
    const copy = [...arr];

    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * i);
        const temp = copy[i];
        copy[i] = copy[j];
        copy[j] = temp;
    }
    return copy;
}
